const FEMALE_ENDINGS = [
  "α", "η", "ου", "ω", "ια", "ινα", "ενη", "αναη", "ρα", "λα", "να", "σα", "τα",
];

const KNOWN_MALE_NAMES = [
  "Νίκος", "Γιώργος", "Δημήτρης", "Αλέξανδρος", "Κώστας", "Θανάσης",
  "Παναγιώτης", "Βασίλης", "Μανώλης", "Στέφανος", "Ροκάς", "Λευτέρης",
  "Ορέστης", "Άρης", "Νεκτάριος", "Φίλιππος", "Σπύρος", "Διάβολος", "Σπαρτιάτης",
  "Αστροναύτης", "Φοίνικας", "Γιάννης", "Θοδωρής", "Σάκης", "Αντρέας", "Χάρης",
  "Μάριος", "Λάμπρος", "Ορφέας", "Νίκος Α.", "Τάσος", "Τάκης", "ΑΕΚτζής", "Λιοντάρι", "Πάνκι",
];

function normalizeGreekName(value: string): string {
  return value
    .toLocaleLowerCase("el-GR")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[._-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

const NORMALIZED_MALE_NAMES = KNOWN_MALE_NAMES.map(normalizeGreekName);

export function inferGenderFromName(displayName: string): "male" | "female" {
  const normalized = normalizeGreekName(displayName);
  const firstToken = normalized.split(" ")[0] ?? "";

  if (!firstToken) return "male";
  if (NORMALIZED_MALE_NAMES.includes(firstToken) || NORMALIZED_MALE_NAMES.includes(normalized)) {
    return "male";
  }

  for (const ending of FEMALE_ENDINGS) {
    if (firstToken.endsWith(ending)) return "female";
  }

  return "male";
}
